<template>
    <div class="youtube-player">
        <youtube
            :video-id="id"
            ref="youtube"
            width="100%"
            height="100%"
            @paused="pausedHandler"
        />

        <div
            class="youtube-thumbnail-block"
            v-if="!playing"
            @click="playVideo"
        >
            <img class="youtube-thumbnail youtube-thumbnail--desktop" :src="asset(thumbnailDesktop)" v-if="!dirty">
            <img class="youtube-thumbnail youtube-thumbnail--mobile" :src="asset(thumbnailMobile)" v-if="!dirty">
            <img class="youtube-play-btn" :src="asset('/images/motor-show-play-video.svg')">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            thumbnailDesktop: String,
            thumbnailMobile: String,
            model: Object
        },

        computed: {
            player() {
                return this.$refs.youtube.player
            }
        },

        data() {
            return {
                playing: false,
                dirty: false
            }
        },

        methods: {
            playVideo() {
                this.playing = true
                this.dirty = true
                this.player.playVideo()
                
                this.$gtag.event('Click', {
                    'event_category': (this.model && this.model.model ) ? this.model.model.slug : this.model.car_model_category,
                    'event_label': 'Vdo',
                });
            },

            pausedHandler() {
                // Check play/pause state after 800ms delay to prevent seek detected as paused issue
                setTimeout(() => {
                    this.player.getPlayerState().then((state) => {
                        if (state == 2) this.playing = false
                    })
                }, 800);
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/variables';

    .youtube-player {
        height: 100%;
        position: relative;

        .youtube-thumbnail-block {
            position: absolute;
            z-index: 1;
            top: 0;
            width: 100%;
            height: 100%;

            .youtube-thumbnail {
                width: 100%;
                height: 100%;
                object-fit: cover;

                &--desktop {
                    display: none;
                    
                    @media ($md) {
                        display: block;
                    }
                }

                &--mobile {
                    display: block;
                    
                    @media ($md) {
                        display: none;
                    }
                }
            }

            .youtube-play-btn {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 57px;
                height: 57px;

                @media ($md) {
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/motor-show/YoutubePlayer.vue